import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONSTANTS } from './constants';
import { environment, Sport } from 'environments/environment';
import {
    values as _values,
    map as _map,
    some as _some
} from 'lodash';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
    // eslint-disable-next-line complexity
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const apiUrls = _values(environment.apis);

        // If fetching "local" files using the HTTP client, allow the request to go without modification
        if (request.url.includes('assets')) {
            return next.handle(request);
        }

        if (request.url.includes('>>')) {
            // a URL that includes a >> is one that is sport dependent so we need to sub in the correct
            // URL for the api request
            const splitURL = request.url.split('>>');
            const api: Sport = splitURL[0] as Sport;
            const apiURL = CONSTANTS.apiRoots[api];
            const url = apiURL?.concat(splitURL[1]);

            request = request.clone({
                url
            });
        }

        const apiUrlDomains = _map(apiUrls, (url) => {
            // This regex extracts the domain part (everything between the protocol:// and the next '/')
            const match = url.match(/:\/\/(.*?)\/?$/);

            // Gets the last two parts of the domain (e.g., 'sportlogiq.com')
            return match ? match[1].split('.').slice(-2).join('.') : '';
        });

        // Check if the request.url includes any of the extracted domain parts
        const isApiUrl = _some(apiUrlDomains, (domainPart) => {
            // Ensure the domainPart is not empty before checking
            return domainPart && request.url.includes(domainPart);
        });

        // include cookies in any sportlogiq calls
        if (isApiUrl) {
            request = request.clone({
                withCredentials: true
            });
        }

        return next.handle(request);
    }
}
